import classNames from 'classnames';
import React, { useRef, useState } from 'react';
import './index.scss';

interface EfScrollProps {
    /**
     * 样式名
     */
    className?: string;
    /**
     * 子内容
     */
    children?: React.ReactNode[] | React.ReactNode;
}

/**
 * 维护:谢保林
 *
 * 左右划动
 */
const EfScroll: React.FC<EfScrollProps> = ({ children, className }) => {
    const prefixCls = `ef-scroll`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
    });
    const refWrapper = useRef(null);
    const [disabledTool, setDisabledTool] = useState('prev');
    const oneScrollWidth = 300;
    // 设置左右是否置灰
    const setDisabledToolHandle = () => {
        const elem: any = refWrapper.current;
        if (elem) {
            setTimeout(() => {
                const scrollLeft: any = elem?.scrollLeft; // 已滚动距离
                const maxScrollWidth = elem.scrollWidth - elem.clientWidth - 10; //最大可滚动距离

                if (scrollLeft <= 10) {
                    setDisabledTool('prev');
                } else if (scrollLeft >= maxScrollWidth) {
                    setDisabledTool('next');
                } else {
                    setDisabledTool('');
                }
            }, 200);
        }
    };
    // 点击上一个
    const toPrevHandle = () => {
        const elem: any = refWrapper.current;
        if (elem) {
            elem.scrollBy(-oneScrollWidth, 0);
            setDisabledToolHandle();
        }
    };
    // 点击下一个
    const toNextHandle = () => {
        const elem: any = refWrapper.current;
        if (elem) {
            elem.scrollBy(oneScrollWidth, 0);
            setDisabledToolHandle();
        }
    };
    return (
        <div className={classes}>
            <div className="ef-scroll-wrapper" ref={refWrapper}>
                {children}
            </div>
            <div className="ef-scroll-tools">
                <span className={`ef-scroll-prev${disabledTool === 'prev' ? ' ef-scroll-disabled' : ''}`} onClick={toPrevHandle}></span>
                <span className={`ef-scroll-next${disabledTool === 'next' ? ' ef-scroll-disabled' : ''}`} onClick={toNextHandle}></span>
            </div>
        </div>
    );
};

export default EfScroll;
